import { ToastrService } from 'ngx-toastr';
import { SelectDiagnosticsDialogComponent } from './select-diagnostics-dialog/select-diagnostics-dialog.component';
import { DiagnosticVM } from './../../../../Elearning-Models';
import { environment } from './../../../../../environments/environment';
import { Router } from '@angular/router';
import { DiagnosticsVM } from 'src/app/Elearning-Models';
import { Component, Input, OnInit } from '@angular/core';
import { DiagnosticsDataService } from 'src/app/Services/diagnosticsData.service';
import { IAPIService } from 'src/app/Services/API-Service/IAPIService';
import { IServiceFactory } from 'src/app/Services/service-factory';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-class-panel',
  templateUrl: './class-panel.component.html',
  styleUrls: ['./class-panel.component.scss']
})
export class ClassPanelComponent implements OnInit {
  @Input() diagnostics: DiagnosticsVM;
  diagnosticsData: DiagnosticsVM;
  diagnosticsLoading: boolean = false;

  private diagnosticsDataService: DiagnosticsDataService;

  constructor(
    private router: Router,
    private serviceFactory: IServiceFactory,
    private APIService: IAPIService,
    private dialog: MatDialog,
    private toastr: ToastrService
  ) {
    this.diagnosticsDataService = this.serviceFactory.getDiagnosticsDataService();
  }

  ngOnInit(): void {
    this.diagnosticsData = this.diagnostics;
  }

  onAddDiagnosticClick = () => {
    this.openSelectDiagnosticDialog();
  }

  getDiagnosticData = (diagnosticExamID: number) => {
    this.diagnosticsLoading = true;
    this.APIService.GetDiagnosticDataByDiagnosticExamID(diagnosticExamID).subscribe((response: DiagnosticVM) => {
      this.diagnostics.Diagnostics.push(response);
      this.diagnosticsLoading = false;
      this.toastr.success('Diagnostic Added', 'Success!');
    })
  }

  onDiagnosticClick = (diagnostic: DiagnosticVM) => {
    this.router.navigate(
      [environment.rootPath + 'Diagnostic/' + diagnostic.DiagnosticExamID],
      {
        queryParams: {
          className: this.diagnostics.ClassName,
          lessonName: diagnostic.LessonName,
          classID: this.diagnostics.ClassID
        }
      }
    )
  }

  openSelectDiagnosticDialog = () => {
    const dialogRef = this.dialog.open(SelectDiagnosticsDialogComponent, {
      data: {
        hbClassID: this.diagnostics.ClassID, // Confirm how to get teacher ID
        title: this.diagnostics.ClassName,
      },
      autoFocus: false,
    });

    const sub = dialogRef.componentInstance.diagnosticSelected.subscribe(
      (diagnosticExamID) => {
        this.getDiagnosticData(diagnosticExamID);
      }
    );

    dialogRef.afterClosed().subscribe((result) => {
      sub.unsubscribe();
    });
  }

}
